import { Injectable, TemplateRef } from "@angular/core";

@Injectable({
   providedIn: "root",
})
export class ToastService {
   toasts: any[] = [];
   constructor() {}

   show(textOrTempl: string | TemplateRef<any>, title: string, message: string, iconClass: string, options: any = {}) {
      this.toasts.push({ textOrTempl, title, message, iconClass, ...options });
   }
   remove(toast: any) {
      this.toasts = this.toasts.filter((t) => t !== toast);
   }
}
